<!-- <div class="container">
  <form #timeForm="ngForm" (ngSubmit)="onSubmit()">
    <div class="row" *ngFor="let day of days" class="mb-1 d-flex align-items-center">
      <div class="custom-control custom-checkbox col-md-1">
        <input
          type="checkbox"
          class="custom-control-input"
          [id]="day.name"
          [(ngModel)]="day.selected"
          name="{{ day.name }}Checked"
        />
        <label class="custom-control-label" [for]="day.name">{{ day.label }}</label>
      </div>

      <div *ngIf="day.selected" class="col-md-3 d-flex align-items-center">
        <label class="mr-2">Başlangıç</label>
        <ngb-timepicker
          [(ngModel)]="day.startTime"
          name="{{ day.name }}StartTime"
          [spinners]="false"
          class="timepicker"
        ></ngb-timepicker>
      </div>

      <div *ngIf="day.selected" class="col-md-3 d-flex align-items-center">
        <label class="mr-2">Bitiş</label>
        <ngb-timepicker
          [(ngModel)]="day.endTime"
          name="{{ day.name }}EndTime"
          [spinners]="false"
          class="timepicker"
        ></ngb-timepicker>
      </div>
    </div>
    <button type="submit" class="btn btn-primary">Kaydet</button>
  </form>
</div> -->

<!-- <div class="form-group col-md-3 col-sm-12">
  <div class="input-group">
    <input name="datepicker" class="form-control" ngbDatepicker #datepicker="ngbDatepicker"
      placeholder="yyyy-mm-dd - yyyy-mm-dd" [value]="displayDateRange()" (click)="datepicker.toggle()"
      (dateSelect)="onDateSelection($event)" [autoClose]="'outside'" [dayTemplate]="rangeSelectionDP"
      outsideDays="hidden" [startDate]="fromDate!" />
    <ng-template #rangeSelectionDP let-date let-focused="focused">
      <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
        [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
        (mouseleave)="hoveredDate = null">
        {{ date.day }}
      </span>
    </ng-template>
    <div class="input-group-append">
      <button class="btn btn-outline-secondary feather icon-calendar" (click)="datepicker.toggle()" type="button"></button>
    </div>
  </div>
</div>


<ngb-timepicker [(ngModel)]="basicTP" *ngIf="startFilterDate && (startFilterDate == endFilterDate)"></ngb-timepicker>

<ngb-timepicker [(ngModel)]="basicTP2" *ngIf="startFilterDate && (startFilterDate == endFilterDate)"></ngb-timepicker> -->
<!-- <img [src]="logo" alt="resim yok" class="image" />
<img src="/assets/images/misc/leaf-orange.png" alt="resim yok" class="image" /> -->
<button type="submit" class="btn btn-primary" (click)="generatePDF({
  firmaLogo: '/assets/images/logo/siyahlogo.png',
  firmaAdi: 'Rezonans BiyoMedikal Kalibrasyon Elektronik Teknolojileri San. ve Tic. Ltd. Sti',
  firmaAdresi: 'Yazlık Yenimahalle Osmanlı Cad. No:5/1 Gölcük / Kocaeli',
  akraditationFirma: 0,
  akraditationNo:'AB-007-CL',
  certificateNo:'SN25-0079',
  certificateTarih:'01.25'
}, {
  deviceOwner: 'Ahmet Yılmaz',
  address: 'Yazlık, Gölcük, Kocaeli',
  orderNumber: 'ORD12345',
  deviceName: 'Model XYZ',
  manufacturer: 'ABC Tech',
  modelType: 'XYZ-500',
  serialNumber: 'SN123456',
  calibrationDate: '2025-02-26',
  kalYapan:'Mehmet Yalçın',
  onaylayan:'Mehmet Yalçın',
  certificateNo:'20250009'
}, {
  measurementUncertainty: '± 0.05%',
  calibrationMethod: 'Method XYZ',
  references: [
    {
      deviceName: 'Device A',
      brand: 'Brand A',
      model: 'Model A',
      serialNumber: 'SN001',
      certificateNumber: 'CERT123',
      calibrationDate: '2024-12-12',
      tracebility:'AK-0007'
    },
    {
      deviceName: 'Device B',
      brand: 'Brand B',
      model: 'Model B',
      serialNumber: 'SN002',
      certificateNumber: 'CERT124',
      calibrationDate: '2024-12-13',
      tracebility:'AK-0009'
    }
  ],
  device: {
    deviceName: 'Manometre',
    serialNo: '.0033',
    deviceNumber: '-',
    location: 'işletme içi',
    brand: 'PAKKENS',
    type: 'Analog/Kuru tip /63mı',
    range: '0-25 bar',
    resolution: '1 bar',
    incomingDateOfDeviceLaboratory: '7.01.2025',
    visualFunctionInspectionDevice: 'uygun'
  },
  remarks: 'Calibration successful, no issues found.'
})">Pdf Deneme</button>
<br>
<input type="file" accept=".pdf" (change)="onFileSelected2($event)">

<div id="pdf-container"></div> <!-- PDF sayfaları burada görünecek -->